export const checkAuthStatusPath = "/api/v0/preAuthorize/status";
export const notifySuccessfulAuthPath = "/api/v0/preAuthorize/success";
export const notifyFailedAuthPath = "/api/v0/preAuthorize/failure";
export const revokeUserAuthPath = "/api/v0/preAuthorize/revoke";
export const paymentMethodPath = "/api/v0/paymentMethods";
